import dayjs from 'dayjs';
import { FormattedMessage, useIntl } from 'react-intl';
import footerlogo from 'Assets/img/logomark.svg';

const LoginFooter = () => {
  const { formatMessage } = useIntl();

  return (
    <footer className="tw:py-6 tw:px-4 tw:text-center tw:text-xs tw:text-gray-600">
      <div className="tw:flex tw:flex-wrap tw:items-center tw:justify-center tw:gap-x-2 tw:gap-y-1">
        <img
          src={footerlogo}
          alt={formatMessage({
            id: 'sign-in-footer-logo-alt',
            defaultMessage: 'Nui Markets logo',
          })}
          className="tw:w-5 tw:opacity-75"
        />
        <span data-test-class="playwright-hide">
          &copy; 2014 - {dayjs().year()} Nui Markets
        </span>
        <span className="tw:hidden tw:sm:inline">|</span>
        <span>
          <strong className="tw:text-gray-900 tw:pr-1">
            <FormattedMessage
              id="sign-in-page-footer-trouble-signing-in"
              defaultMessage="Trouble signing in?"
            />
          </strong>
          <a
            href="https://www.nuimarkets.com/contact/"
            title={formatMessage({
              id: 'sign-in-contact-us-title',
              defaultMessage: 'Contact us if you are having trouble signing in',
            })}
            target="_blank"
            rel="noopener noreferrer"
            className="tw:text-primary tw:underline tw:hover:opacity-80"
          >
            <FormattedMessage
              id="sign-in-page-footer-contact-us"
              defaultMessage="Contact us"
            />
          </a>
        </span>
      </div>
      <ul className="tw:flex tw:items-center tw:justify-center tw:gap-3 tw:mt-3">
        <li>
          <a
            href="https://www.nuimarkets.com/privacy/"
            title={formatMessage({
              id: 'sign-in-privacy-policy-title',
              defaultMessage: 'Privacy policy',
            })}
            target="_blank"
            rel="noopener noreferrer"
            className="tw:text-primary tw:underline tw:hover:opacity-80"
          >
            <FormattedMessage
              id="sign-in-page-footer-privacy-policy"
              defaultMessage="Privacy policy"
            />
          </a>
        </li>
        <li aria-hidden="true" className="tw:text-gray-400">
          |
        </li>
        <li>
          <a
            href="https://www.nuimarkets.com/terms/"
            title={formatMessage({
              id: 'sign-in-legal-terms-title',
              defaultMessage: 'Legal terms',
            })}
            target="_blank"
            rel="noopener noreferrer"
            className="tw:text-primary tw:underline tw:hover:opacity-80"
          >
            <FormattedMessage
              id="sign-in-page-footer-legal-terms"
              defaultMessage="Legal terms"
            />
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default LoginFooter;
